import { render, staticRenderFns } from "./TitlePhotoForProject.vue?vue&type=template&id=c908a694&scoped=true&"
import script from "./TitlePhotoForProject.vue?vue&type=script&lang=js&"
export * from "./TitlePhotoForProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c908a694",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c908a694')) {
      api.createRecord('c908a694', component.options)
    } else {
      api.reload('c908a694', component.options)
    }
    module.hot.accept("./TitlePhotoForProject.vue?vue&type=template&id=c908a694&scoped=true&", function () {
      api.rerender('c908a694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/TitlePhotoForProject.vue"
export default component.exports